export const formattedDate = (value) => {
    if (value !== null && value !== '') {
        return `${parseInt(value.substring(8, 10))}. ${parseInt(value.substring(5, 7))}. ${value.substring(0, 4)}`
    }
    return ''
}

export const formattedPrice = (value) => {
    return Math.round(value).toLocaleString('cs-CZ')
}